export default {
    'name': 'tiff',
    'width': '88',
    'height': '76',
    'viewBox': '0 0 76 88',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 23.2409V80H71.1111V0H22.4796L0 23.2409Z\' fill=\'#DBEFFF\'/><rect width=\'47\' height=\'23\' transform=\'translate(29 49)\' fill=\'#006CFD\'/><path d=\'M41.0242 66V57.642H37.7622V56.2H46.0782V57.642H42.7882V66H41.0242ZM47.696 66V56.2H49.46V66H47.696ZM52.1634 66V56.2H58.9114V57.642H53.9274V60.666H58.2814V62.108H53.9274V66H52.1634ZM60.7187 66V56.2H67.4667V57.642H62.4827V60.666H66.8367V62.108H62.4827V66H60.7187Z\' fill=\'white\'/>'
}
